import React, { useEffect, useRef } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import { useModule } from "../../context/ModuleContext";

const SideNav = ({ isOpen, onClose, accessMap }) => {
  const sideNavRef = useRef(null);
  const location = useLocation();
  const { selectedModule } = useModule();

  /* ===============================
     CLOSE ON OUTSIDE CLICK
  ================================ */
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sideNavRef.current && !sideNavRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  /* ===============================
     ROLE-BASED FUNCTIONS
  ================================ */

  const allowedFunctions = selectedModule?.functions
    ? selectedModule.functions
      .filter((fn) => fn.status === "ACTIVE") // optional but recommended
      .map((fn) => ({
        name: fn.name,
        uriPath: fn.uriPath,
      }))
    : [];

 
  return (
    <Box
      ref={sideNavRef}
      sx={{
        position: "fixed",
        top: "64px",
        right: isOpen ? 0 : "-250px",
        width: "250px",
        height: "calc(100vh - 64px)",
        backgroundColor: "#fff",
        boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
        transition: "right 0.3s ease-in-out",
        zIndex: 1000,
        overflowY: "auto",
      }}
    >
      {/* MODULE TITLE */}
      <Typography
        variant="h6"
        sx={{ p: 2, color: "#007bff", fontWeight: "bold" }}
      >
        {selectedModule?.name || "Navigation"}
      </Typography>

      {/* FUNCTIONS */}
      <List>
        {allowedFunctions.map((fn, index) => (
          <ListItem
            button
            key={index}
            component={Link}
            to={fn.uriPath}
            sx={{
              backgroundColor:
                location.pathname === fn.uriPath ? "#007bff" : "transparent",
              color:
                location.pathname === fn.uriPath ? "#fff" : "text.primary",
              "&:hover": {
                backgroundColor: "#007bff",
                color: "#fff",
              },
            }}
          >
            <ListItemIcon
              sx={{
                color:
                  location.pathname === fn.uriPath
                    ? "#fff"
                    : "text.secondary",
              }}
            >
              <Inventory2OutlinedIcon />
            </ListItemIcon>

            {/* FUNCTION NAME */}
            <ListItemText primary={fn.name} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default SideNav;
